import { fixFloatValue } from "../pages/components/helpers";
import moment from "moment";

export default {
  methods: {
    lam2vol(lam, area, ef) {
      return fixFloatValue(lam * (area * 10) / ef);
    },
    // Mesma conta do backend (services/calcManagement.js): dia − plantio + 1 + OFFSET_DAP.
    calcNDC(plantingDate, time, offsetDap = 0) {
      const planting_Date = moment(plantingDate, "YYYY-MM-DD");
      const DAPTime = moment(time, "YYYY-MM-DD");

      const ndc = DAPTime.diff(planting_Date, "days") + 1 + Number(offsetDap || 0);

      return ndc > 0 ? ndc : 0;
    },
    calcIrrigationTime(
      liquidBlade,
      eficiency,
      divisor,
      area,
      type = "registered-application-fee"
    ) {
      let irrigationTime;
      let brutalBlade = liquidBlade / eficiency;

      if (type === "flow") {
        const vol = brutalBlade * area * 10;

        irrigationTime = (vol / divisor) * 60;
      } else {
        irrigationTime = (brutalBlade / divisor) * 60;
      }

      if(isFinite(irrigationTime)){
        return fixFloatValue(irrigationTime);
      }
      return 0
    },
    calcSoilStorage(waterDisponibility, depthRoot) {
      return fixFloatValue(waterDisponibility * depthRoot);
    },
    calcBladeSuggestion(indexDAP, farmsDAP) {
      let negativeAccumulated;
      if (indexDAP !== 0) {
        negativeAccumulated =
          farmsDAP[indexDAP - 1].NEGATIVE_ACCUMULATED +
          farmsDAP[indexDAP].ETR_PREDICTION;
      } else {
        negativeAccumulated = farmsDAP[indexDAP].ETR_PREDICTION;
      }

      //Gambiarra para inverter valores
      return fixFloatValue( -1 * negativeAccumulated);
    },
    calcIrrigatedBlade(vol, area, eficiency) {
      return fixFloatValue((vol * eficiency) / (area * 10));
    },
    calcNegativeAccumulated(Etr, irrigatedBlade) {
      let negativeAccumulated = fixFloatValue(Etr + irrigatedBlade);

      if (negativeAccumulated > 0) {
        negativeAccumulated = 0;
      }

      return negativeAccumulated;
    },
    calcEtr(initialStorage, maxStorage, availability, Etc, Ks) {
      let Etr;

      if(initialStorage > maxStorage){
        initialStorage = maxStorage
      }

      if (initialStorage / maxStorage > 1 - availability) {
        Etr = -1 * Etc; // Tirar o KS
      } else {
        Etr = -1 * Etc * Ks;
      }

      return fixFloatValue(Etr);
    },
    calcInitialStorage(index, farmsDAP) {
      if (index === 0) {
        return 0;
      } else {
        const { FINAL_STORAGE } = farmsDAP.find(
          (farmDAP, indexFarmDAP) => indexFarmDAP === index - 1
        );

        return FINAL_STORAGE;
      }
    },
    calcFinalStorage(farmDAP) {
      let {
        ETR,
        RAINFALL,
        RAINFALL_INPUT,
        INITIAL_STORAGE,
        MAX_STORAGE,
        IRRIGATED_BLADE,
        RAIN_THRESHOLD_1,
        RAIN_THRESHOLD_2,
        RAIN_FACTOR_1,
        RAIN_FACTOR_2,
        RAIN_FACTOR_3,
      } = farmDAP;

      const rawRainfall = RAINFALL_INPUT !== null ? RAINFALL_INPUT : RAINFALL;

      const t1 = Number(RAIN_THRESHOLD_1) || 0;
      const t2 = Number(RAIN_THRESHOLD_2) || 0;
      const f1 = RAIN_FACTOR_1 ?? 1;
      const f2 = RAIN_FACTOR_2 ?? 1;
      const f3 = RAIN_FACTOR_3 ?? 1;

      let rainFactor;
      if (t1 === 0 && t2 === 0) {
        // Sem limiares distintos: F1 aplica-se a toda precipitação
        rainFactor = f1;
      } else if (rawRainfall <= t1) {
        rainFactor = f1;
      } else if (rawRainfall <= t2) {
        rainFactor = f2;
      } else {
        rainFactor = f3;
      }

      const rainfall = rawRainfall * rainFactor;

      let excess = 0;
      let initialStorage = INITIAL_STORAGE

      if(INITIAL_STORAGE > MAX_STORAGE){
        const diff = Number(INITIAL_STORAGE) - MAX_STORAGE
        excess += diff
        initialStorage = MAX_STORAGE
      }

      let finalStorage = initialStorage + ETR + rainfall;

      if(finalStorage > MAX_STORAGE){
        finalStorage = MAX_STORAGE
      }

      if(finalStorage + IRRIGATED_BLADE > MAX_STORAGE){
        excess += (finalStorage + IRRIGATED_BLADE) - MAX_STORAGE
        finalStorage = MAX_STORAGE
      }
      else {
        finalStorage += IRRIGATED_BLADE;
      }

      if (finalStorage < 0 || !finalStorage) {
        finalStorage = 0;
      }

      return [fixFloatValue(finalStorage), excess, fixFloatValue(rainfall)];
    },
    // calcFinalStorageExcess(farmDAP) {
    //   const {
    //     FINAL_STORAGE,
    //     IRRIGATED_BLADE,
    //     MAX_STORAGE
    //   } = farmDAP;

    //   let excess = 0;

    //   if (FINAL_STORAGE + IRRIGATED_BLADE > MAX_STORAGE) {
    //     excess = FINAL_STORAGE + IRRIGATED_BLADE - MAX_STORAGE;
    //   }

    //   return excess >= 0 ? fixFloatValue(excess) : 0;
    // },
    calcKs(initialStorage, maxStorage, availability,index) {
      if(initialStorage > maxStorage){
        initialStorage = maxStorage
      }
      const percentageOcuppied = initialStorage / maxStorage;

      if (percentageOcuppied > 1 - availability) {
        return 1;
      }

      return fixFloatValue(
        Math.log(initialStorage + 1) / Math.log(maxStorage + 1)
      );
    },

    calcKlFactor(plantOccupancyPortion) {
      return fixFloatValue(Math.sqrt(plantOccupancyPortion));
    },
    calcPlantOccupancyPortion(depthRoot, lineSpacement, plantSpacement) {
      let plantOccupancySpace;

      if (lineSpacement == 0 && plantSpacement == 0) {
        return 0;
      }

      plantOccupancySpace =
        (depthRoot * plantSpacement) / (lineSpacement * plantSpacement);

      return fixFloatValue(plantOccupancySpace > 1 ? 1 : plantOccupancySpace);
    },
    calcEtc(ET0, kc, klFactor) {
      let Etc;

      Etc = ET0 * klFactor * kc; // TO-DO: klFactor retornar 1

      return fixFloatValue(Etc);
    }
  }
};
